/** Product branding. NextGen CRM is built and powered by DataDove. */
export const BRAND = {
  name: "NextGen CRM",
  pitch: "The CRM built for manufacturers",
  icon: "/brand/icon.png",
  vendor: {
    name: "DATADOVE",
    url: "https://datadove.tech",
    logo: "/brand/logo-horizontal.png",
    logoOnDark: "/brand/logo-horizontal-white.png",
    tagline: "Automate. Innovate. Elevate.",
  },
} as const;
